import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import Tooltip from 'components/controls/Tooltip';
import FontIcon from 'components/icons/FontIcon';
import PcrSelectorFilesDialog from 'components/v2/pcr-selector/pcr-selector/PcrSelectorFilesDialog';
import { FileModel } from 'services/EpdClient';
import FileService from 'services/FileService';

interface Props {
  pcrType: 'main' | 'cpcr';
  files: FileModel[];
}

const WizardPcrSelectorSectionDownload: React.FC<Props> = ({ pcrType, files }) => {
  const [isFileSelectorVisible, setIsFileSelectorVisible] = useState<boolean>(false);
  const isDisabled = files.length === 0;
  const needFileSelector = files.length >= 2;

  const handleClick = () => {
    if (needFileSelector) {
      setIsFileSelectorVisible(true);
      return;
    }
    window.open(FileService.getImageUrl(files[0].id || ''), '_blank', 'noreferrer');
  };

  return (
    <>
      <StyledButton onClick={handleClick} disabled={isDisabled} aria-label="Download PCR">
        <StyledFontIcon icon="download" />

        {isDisabled && <Tooltip position="bottom">No file to download</Tooltip>}
      </StyledButton>

      {needFileSelector && (
        <PcrSelectorFilesDialog
          files={files}
          pcrType={pcrType}
          isOpened={isFileSelectorVisible}
          onHide={() => setIsFileSelectorVisible(false)}
        />
      )}
    </>
  );
};

export default WizardPcrSelectorSectionDownload;

const StyledButton = styled.button`
  all: unset;
  width: 24px;
  height: 24px;
  color: ${(props) => props.theme.colors.primaryOrange};
  cursor: pointer;

  ${(props) =>
    props.disabled &&
    css`
      color: ${(props) => props.theme.colors.elementsButtonDisabled};
      cursor: default;
    `}
`;

const StyledFontIcon = styled(FontIcon)`
  font-size: 24px;
  line-height: 1;
`;
